import { useState } from "react";
import { AppContext } from "./AppContext";

const AppContextProvider = ({ children }) => {
  const [entityName, setEntityName] = useState(null);
  const [totalPublications, setTotalPublications] = useState(null);
  const [percentIncrease, setPercentIncrease] = useState(null);
  const [filterByData, setFilterByData] = useState(null);
  const [selectedFilterBy, setSelectedFilterBy] = useState(null);
  const [selectedFilterByLabel, setSelectedFilterByLabel] = useState(null);
  const [metaInfo, setMetaInfo] = useState(null);

  const changeEntityName = (name) => {
    setEntityName(name);
  };

  const changeTotalPublications = (total) => {
    setTotalPublications(total);
  };

  const changePercentIncrease = (percent) => {
    setPercentIncrease(percent);
  };

  const changeFilterByData = (data) => {
    setFilterByData(data);
  };

  const changeSelectedFilterBy = (value) => {
    setSelectedFilterBy(value);
  };

  const changeSelectedFilterByLabel = (value) => {
    setSelectedFilterByLabel(value);
  };
  const changeMetaInfo = (value) => {
    setMetaInfo(value);
  };

  //   const logout = () => {
  //     setUser(null);
  //   };

  return (
    <AppContext.Provider
      value={{
        entityName,
        changeEntityName,
        totalPublications,
        changeTotalPublications,
        percentIncrease,
        changePercentIncrease,
        filterByData,
        changeFilterByData,
        selectedFilterBy,
        changeSelectedFilterBy,
        selectedFilterByLabel,
        changeSelectedFilterByLabel,
        metaInfo,
        changeMetaInfo,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};

export default AppContextProvider;
